<script lang="ts">
  import { getAppConfig } from '../../../../common/config/app-config';
  import { pdpAppleCarePlusServiceSelectedItem } from '../../store/pdp_store';
  import ServiceOption from './ServiceOption.svelte';
  export let vasEntry;
  export let serviceBlock;
  export let currency;
  let activeBaseVasPrice = null;
  let active = false;
  $: updatePDPStoreWithSelectedItem(activeBaseVasPrice);
  function updatePDPStoreWithSelectedItem(activeBaseVasPrice) {
    if (activeBaseVasPrice) {
      const { serviceProductCode, combinedVas, vasGroup, showApplyService, upgradeVasEntry, installService } = vasEntry;
      const {
        CSRFToken,
        productDetails: { code: pdpProductCode },
      } = getAppConfig();
      const {
        vasType: { code },
        priceType,
        priceTo,
        additionalAwsProductCode,
        additionalAwsVasGroup,
        defaultWarranty,
      } = activeBaseVasPrice;
      pdpAppleCarePlusServiceSelectedItem.set({
        vasProductCode: serviceProductCode,
        vasType: code,
        priceType,
        priceTo,
        productCode: pdpProductCode,
        additionalAwsProductCode,
        additionalAwsVasGroup,
        combinedVas,
        qty: 1,
        vasGroup,
        showApplyService,
        CSRFToken,
        defaultWarranty,
        upgradeService: upgradeVasEntry,
        installService,
      });
    } else {
      pdpAppleCarePlusServiceSelectedItem.set(null);
    }
  }
  function handleVasPriceTileClick(vasPrice) {
    active = !active;
    if (activeBaseVasPrice === vasPrice) {
      activeBaseVasPrice = null;
    } else {
      activeBaseVasPrice = vasPrice;
    }
  }
</script>

<div class="apple-service-container">
  {#if vasEntry.vasPrices && vasEntry.vasPrices.length > 0}
    {#each vasEntry.vasPrices as vasPrice}
      <ServiceOption
        {active}
        optionCode={vasPrice?.vasType?.name}
        {currency}
        optionName={serviceBlock?.label}
        optionPrice={vasPrice?.servicePrice?.formattedValue}
        on:click={() => handleVasPriceTileClick(vasPrice)}
      />
    {/each}
  {/if}
</div>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .apple-service-container {
    cursor: pointer;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    :global {
      .mdc-layout-grid {
        padding: 0;
      }
    }
  }
</style>
